import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@beeldit/core/actions/create/CreateActionContext";
import { CreateActionProvider as ChargesCreateActionProvider } from "@beeldit/core/actions/create/CreateActionContext";
import DebtsTablePage from "../components/DebtsTablePage";
import { EditActionProvider } from "@beeldit/core/actions/edit/EditActionContext";

function DebtsPage(props: {filters?: any, formDefaultValues?: any, formFilterValues?: any}) {
  const { filters, formDefaultValues, formFilterValues } = props;

  const tablePageParams = {
    modelConfig: config, // Configuración del modelo
    formDefaultValues: formDefaultValues || null, // Valores por defecto del formulario
    filters: filters || null, // Filtros para la tabla
    formFilterValues: formFilterValues || null, // Valores por defecto del formulario de filtros
  }

  return (
    <ListActionProvider key={config.modelName}>
      <RemoveActionProvider>
        <CreateActionProvider>
          <EditActionProvider>
            <ChargesCreateActionProvider>
              <DebtsTablePage {...tablePageParams} />
            </ChargesCreateActionProvider>
          </EditActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}

export default DebtsPage;
